import FizConfig from "./FizConfig.js";
import * as i18n from "./i18n.ts";
import * as FwDatas from "./FwDatas.ts";
import * as amplify from "./util/amplify.ts";
import * as libLocation from "./lib/location.ts";
import Handlebars from "./lib/handlebars/handlebars.js?amd";
import * as deltatime from "./lib/deltatime.js";
import * as DateUtils from "./lib/DateUtils.ts";
import Icons from "./svg/Icons.ts";
import $ from "./$.js";
  var
    // Private field
    templatesByName = {},
    i18nTemplateByContent = {};

  /*
    Function: addTemplate(name,text)
    Define a template with given name for use in Mustache engine

    Parameter:
      name - string, the name of the template
      text - string, the text of the template
  */
  function addTemplate(name,text){
    if(!templatesByName[name]){
      var template;
      if(typeof text==='string'){
        template = Handlebars.compile(text)
      }else if(typeof text==='function'){
        template = text;
      }else{
        template = Handlebars.template(text)
      }
      Handlebars.registerPartial(name,template);
      templatesByName[name] = template;
    }
    return "MUS!"+name;
  }

  function i18ntemplate(key,ctx,doNotEscape){
    var
      template = i18n.get(key,ctx),
      templateFunction = i18nTemplateByContent[template];
    if(!templateFunction){
      try{
        templateFunction = i18nTemplateByContent[template] = Handlebars.compile(template,{noEscape:!!doNotEscape});
      }catch(e){
        console.log(key,ctx,template);
        console.log(e);
      }
    }
    try{
      return templateFunction(ctx,{allowProtoPropertiesByDefault:true,allowProtoMethodsByDefault :true});
    }catch(e){
      console.log(e);
      amplify.publish('jserror',e);
      return key;
      
    }
  }
  function i18nHelper(contextOrOption, isContext) {
    return i18ntemplate(isContext?contextOrOption:contextOrOption.fn(this),this);
  }
  function MustacheContext(datas){
    $.extend(this,datas);
  }
  /*
    Function: transform(template, view): string
    Apply the given Mustache template to given data (view)
  
    Parameters are replaced with properties found in view; in addition, key
    names may be wrapped in i18n sections to insert translations:
    {{#i18n}}section.key{{/i18n}} and URLs are detected in the text of
    {{#urlText}} sections and replaced with HTML links.
  
    See mustache(5) for details of Mustache template processings:
    http://mustache.github.com/mustache.5.html
  
    Parameters:
      template - string, the template string in Mustache format
      view - object, optional, data with parameters to replace in the template,
        defaults to {} to replace only localization keys
  
    Returns:
      string, the HTML or text resulting from the transformation
  */
  function transform(template,view){
    view = new MustacheContext(view);
  
    try{
      var tpl = typeof template === 'string'?Handlebars.compile(template):template;
      return tpl(view,{allowProtoPropertiesByDefault:true,allowProtoMethodsByDefault :true});
    } catch(e){
      console.log(e);
      console.log("template : ",template);
      throw e;
    }
  }
  function mustache(templateName, datas){
    if(typeof templateName === 'function'){
      return templateName(datas).toHTML();
    }
    //when loaded as Module
    if(templateName.default){
      templateName = templateName.default;
    }
    if(templateName.indexOf('MUS!')===0){
      templateName = templateName.substring(4);
    }
    if (templatesByName[templateName] === undefined ){
      console.log("Mustache template not found: "+templateName);
      return;
    }
    try{
      return transform(templatesByName[templateName],datas);
    } catch(e){
      console.error("Error on template : "+templateName);
      throw e;
    }
  }
  export function mustacheoverride(overide,call){
    var old = Object.assign({},Handlebars.partials)
    try{
      for(var [name,value] of Object.entries(overide)){
        Handlebars.registerPartial(name,Handlebars.compile(value));
      }
      call()
    }finally{
      Handlebars.partials = old;
    }

  }
  Handlebars.registerHelper('tpl',function (val) {
    return new Handlebars.SafeString(mustache(val,this));
  });
  Handlebars.registerHelper('iconlib',function (val,color) {
    var 
      crawler = Icons;
    for(var part of val.split('.')){
      crawler = crawler[part];
      if(crawler===undefined){
        console.log(new Error('cannot find icon '+val))
        return ''
      }
    }
    if(typeof color==='string'){
      crawler = crawler.withColor(color);  
    }
    return crawler;
  });
  Handlebars.registerHelper('iconliburl',function (val,color) {
    var 
      crawler = Icons;
    for(var part of val.split('.')){
      crawler = crawler[part];
      if(crawler===undefined){
        console.log(new Error('cannot find icon '+val))
        return ''
      }
    }
    if(typeof color==='string'){
      crawler = crawler.withColor(color);  
    }
    return crawler.toURL();
  });
  Handlebars.registerHelper('iso',function (val) {
    return val.toISOString();
  });
  Handlebars.registerHelper('isonotime',function (val) {
    return val.toISOString().substring(0,10);
  });
  Handlebars.registerHelper('dateinput',function (val) {
    try{
      return new Handlebars.SafeString(DateUtils.forInputDate(val));
    }catch(e){
      console.log(e)
    }
  });
  Handlebars.registerHelper('datetimeinput',function (date) {
    try{
      return new Handlebars.SafeString(DateUtils.forInputDateTimeLocal(date));
    }catch(e){
      console.log(e)
    }
  });
  Handlebars.registerHelper('i18nNum',function (key, val) {
    return new Handlebars.SafeString(i18n.get(key,val));
  });
  Handlebars.registerHelper('i18n',i18nHelper);
  Handlebars.registerHelper('i18nDyn',i18nHelper);
  Handlebars.registerHelper('i18nsimple',function(key, ctx) {
    return new Handlebars.SafeString(i18n.get(key,ctx));
  });
  Handlebars.registerHelper('birthMaxDate',function(){
    return DateUtils.forInputDate(new Date());
  });
  Handlebars.registerHelper('imageUri',function(uri,w,h,s){
    if(uri.indexOf(FizConfig.API_BASE_URL)!==0){
      return uri;
    }
    if(uri.indexOf('?')===-1){
      uri+='?'
    }else{
      uri+='&';
    }
    return uri+'w='+w+'&h='+h+'&s='+s;
  });
  
  
  Handlebars.registerHelper('log',function(param) {
    console.log(param);
  });
  Handlebars.registerHelper('user',function(options) {
    return options.fn(FwDatas.getUser());
  });
  Handlebars.registerHelper('textareaescape',function(data) {
    if(data){
      return new Handlebars.SafeString(data.replace('<','&lt;').replace('>','&gt;'));
    }
  });
  Handlebars.registerHelper('deltatime',function(date,format,extraCss) {
    if(typeof date==='string'){
      format = date;
      date = new Date();
    }
    if(typeof extraCss!=='string'){
      extraCss="";
    }
    return new Handlebars.SafeString(deltatime.html(date,typeof format==='string'?format:'longdate',extraCss));
  });
  Handlebars.registerHelper('deltatimeraw',function(date) {
    return deltatime.deltatime.longdate(date);
  });
  Handlebars.registerHelper('longDate',function(date,format) {
    if(!(date instanceof Date)){
      date = Fiz.decodeISODate(date);
    }
    if(date===null){
      return '';
    }
    
    return DateUtils.format(date,typeof format==='string'?format:'dddd LL');
  });

  var 
    splash = Math.floor(Math.random()*5)
  Handlebars.registerHelper('$splash',function(context){
    splash = (splash +1)%5;
    this["splash0"+(splash+1)] = true;
  });
  
  Handlebars.registerHelper('var',function(name, value, context){
    if(arguments.length===3){
      this[name] = value;
    }else{
      this[name] = value.fn(this)
    }
  });

  Handlebars.registerHelper('personLink',function(options) {
    if(!this.person){
      return '';
    }
    if(!this.person.accountId){
      return options.fn(this);
    }
    return '<a data-fw-onclick="modaluser|'+encodeURIComponent(this.person.accountId)+'">'+options.fn(this)+'</a>';
  });
  
  Handlebars.registerHelper('placeLink',function(options) {
    try {
      return '<a href="map.php?placeId=' + encodeURIComponent(this.place.placeId) + '">'  + options.fn(this) + '</a>';
    } catch (e) {
      console.log("no place in object",this);
      return options.fn(this);
    }
  });
  Handlebars.registerHelper('familyLink',function(options) {
    return '<a href="settings.php">'+options.fn(this)+'</a>';
  });
  
  Handlebars.registerHelper('premiumPermission',function(permissionName, options) {
    if(typeof permissionName==='function'){
      permissionName = permissionName.apply(this)
    }
    var 
      data = FwDatas.getPermission(permissionName);
    //if it is a if {{#permissionName
    if(options && options.fn){
      if(data && data!=='KO_PREMIUM'){
        return options.fn(this);
      }else{
        return options.inverse(this);
      }
    //if it a direct call {{permissionName 
    }else{
      return data;
    }
    
  });
  Handlebars.registerHelper('if-or',function() {
    var options = arguments[arguments.length-1];
    for(var i=0;i<arguments.length-1;i++){
      if(arguments[i]){
        return options.fn(this);
      }
    }
    return options.inverse(this);
  });
  Handlebars.registerHelper('if-and',function() {
    var options = arguments[arguments.length-1];
    for(var i=0;i<arguments.length-1;i++){
      if(!arguments[i]){
        return options.inverse(this);
      }
    }
    return options.fn(this);
  });
  Handlebars.registerHelper('if-eq',function() {
    var options = arguments[arguments.length-1];
    var val = arguments[0];
    for(var i=1;i<arguments.length-1;i++){
      if(val != arguments[i]){
        return options.inverse(this);
      }
    }
    return options.fn(this);
  });
  Handlebars.registerHelper('if-more',function() {
    var options = arguments[arguments.length-1];
    if(arguments[0]>arguments[1]){
      return options.fn(this);
    }else{
      return options.inverse(this);
    } 
  });
  Handlebars.registerHelper('if-page',function() {
    var 
      options = arguments[arguments.length-1],
      page = libLocation.getPageName();
    
    for(var i=0;i<arguments.length-1;i++){
      if(arguments[i]===page){
        return options.fn(this);
      }
    }
    return options.inverse(this);
  });
  
  Handlebars.registerHelper('FizConfig',function(){
    var options = arguments[arguments.length-1];
    return options.fn(FizConfig);
  });
  Handlebars.registerHelper('families',function(){
    return FwDatas.getFamilies();
  });
  Handlebars.registerHelper('invitations',function(){
    return FwDatas.getInvitations();
  });
  Handlebars.registerHelper('family',function(){
    var options = arguments[arguments.length-1];
    return options.fn(FwDatas.getFamily());
  });
  Handlebars.registerHelper('monofamily',function(){
    return FwDatas.getFamilies().length===1;
  });
  Handlebars.registerHelper('totalNotifCount',function(){
    var res = $.grep(FwDatas.getInvitations(),function(o){
      return o.blockingStatus!=="BlockedShown";
    }).length;
    FwDatas.getFamilies().forEach(function(fam){
      res += fam.wallCounter;
    });
    if(res){
      var options = arguments[arguments.length-1];
      return options.fn(res);
    }
  });
  
  var mustacheContext = MustacheContext.prototype = {
      FizConfig : FizConfig,
      FwDatas:FwDatas,
      'false':false,
      'true':true,
      family : function(){
        return FwDatas.getFamily();
      },
      familyName : function(){
        var family = FwDatas.getFamily();
        if(family){
          return family.name;
        }
      },
      invitations : function(){
        return $.grep(FwDatas.getInvitations(),function(o){
          return o.blockingStatus!=="BlockedShown";
        });
      },
      locale: function() {
        return i18n.getSelectedLanguage();
      }
  };
  
  addTemplate("authorLink",'<a style="word-break: break-word;" data-fw-onclick="modaluser|{{accountId}}">{{#author}}<b>{{name}}</b>{{/author}}</a>');
  addTemplate("listLink",'<a href="tasks.php?metaId={{nested.metaId}}" class="color-branded"><b>{{nested.name}}</b></a>');
  
  var 
    registerHelper = function(a,b,c){
      Handlebars.registerHelper(a,b,c)
    },
    SafeString = Handlebars.SafeString;
  
  export {
    addTemplate,
    transform,
    mustache,
    mustacheContext,
    i18ntemplate as i18n,
    SafeString,
    registerHelper
  }